import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row q-mb-lg q-col-gutter-md" }
const _hoisted_2 = { class: "col q-gutter-md" }
const _hoisted_3 = { class: "col-8 q-gutter-md" }
const _hoisted_4 = { class: "row items-center" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "text-body1 q-pr-md" }, "Date from", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "text-body1 q-pr-md q-pl-md" }, "Date to", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_free_subscriptions_form_field_subscription_type = _resolveComponent("free-subscriptions-form-field-subscription-type")!
  const _component_free_subscriptions_form_field_process_type = _resolveComponent("free-subscriptions-form-field-process-type")!
  const _component_free_subscriptions_form_field_created_by = _resolveComponent("free-subscriptions-form-field-created-by")!
  const _component_free_subscriptions_form_field_user = _resolveComponent("free-subscriptions-form-field-user")!
  const _component_free_subscriptions_form_field_id = _resolveComponent("free-subscriptions-form-field-id")!
  const _component_free_subscriptions_form_field_start_date = _resolveComponent("free-subscriptions-form-field-start-date")!
  const _component_free_subscriptions_form_field_end_date = _resolveComponent("free-subscriptions-form-field-end-date")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_free_subscriptions_form_field_subscription_type, {
        modelValue: _ctx.localModel.subscriptionType,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.localModel.subscriptionType) = $event))
      }, null, 8, ["modelValue"]),
      _createVNode(_component_free_subscriptions_form_field_process_type, {
        modelValue: _ctx.localModel.processType,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.localModel.processType) = $event))
      }, null, 8, ["modelValue"]),
      _createVNode(_component_free_subscriptions_form_field_created_by, {
        modelValue: _ctx.localModel.createdBy,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.localModel.createdBy) = $event))
      }, null, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_free_subscriptions_form_field_user, {
        modelValue: _ctx.localModel.user,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.localModel.user) = $event))
      }, null, 8, ["modelValue"]),
      _createVNode(_component_free_subscriptions_form_field_id, {
        modelValue: _ctx.localModel.id,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.localModel.id) = $event))
      }, null, 8, ["modelValue"]),
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createVNode(_component_free_subscriptions_form_field_start_date, {
          modelValue: _ctx.localModel.startDate,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.localModel.startDate) = $event))
        }, null, 8, ["modelValue"]),
        _hoisted_6,
        _createVNode(_component_free_subscriptions_form_field_end_date, {
          modelValue: _ctx.localModel.endDate,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.localModel.endDate) = $event))
        }, null, 8, ["modelValue"])
      ])
    ])
  ]))
}